export default __webpack_public_path__ + "static/posgresql-f809da03ec6c5fd860f66df3245a71e4.svg";